import { render, staticRenderFns } from "./CompaniesButtonMenu.vue?vue&type=template&id=a60e693e&scoped=true"
import script from "./CompaniesButtonMenu.vue?vue&type=script&lang=js"
export * from "./CompaniesButtonMenu.vue?vue&type=script&lang=js"
import style0 from "./CompaniesButtonMenu.vue?vue&type=style&index=0&id=a60e693e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60e693e",
  null
  
)

export default component.exports